import $ from "jquery";

const scAccordionFilter = () => {
  const init = () => {
    handlerMultipleClick();
    handlerSingleClick();
    handlerReset();
    handlerSearch();
  };

  const el = {
    multiple: '.accordion-data-amenities-list-item, .accordion-data-rules-list-item',
    single: '.accordion-data-beds-list-item',
    reset: '#accordion-reset-btn',
    search: '#accordion-search-btn',
  };

  const queryParams = {
    beds: null,
    amenities: [],
    rules: [],
  };

  const handlerMultipleClick = () => {
    $(document).on('click', el.multiple, function() {
      const value = $(this).data('value');
      const type = $(this).hasClass('accordion-data-amenities-list-item') ? 'amenities' : 'rules';

      if ($(this).hasClass('selected')) {
        $(this).removeClass('selected');
        const index = queryParams[type].indexOf(value);
        if (index > -1) queryParams[type].splice(index, 1);
      } else {
        $(this).addClass('selected');
        if (!queryParams[type].includes(value)) queryParams[type].push(value);
      }
    });
  };

  const handlerSingleClick = () => {
    $(document).on('click', el.single, function() {
      if ($(this).hasClass('selected')) {
        $(this).removeClass('selected');
        queryParams.beds = null;
      } else {
        $(el.single).removeClass('selected');
        $(this).addClass('selected');
        queryParams.beds = $(this).data('value');
      }
    });
  };

  const handlerReset = () => {
    $(document).on('click', el.reset, function() {
      $(el.multiple).removeClass('selected');
      $(el.single).removeClass('selected');
      queryParams.beds = null;
      queryParams.amenities = [];
      queryParams.rules = [];
    });
  };

  const handlerSearch = () => {
    $(document).on('click', el.search, function() {
      const params = new URLSearchParams();

      if (queryParams.beds) params.set('beds', queryParams.beds);
      if (queryParams.amenities.length) params.set('amenities', queryParams.amenities.join(','));
      if (queryParams.rules.length) params.set('rules', queryParams.rules.join(','));
    
      window.location.href = `/rooms?${params.toString()}`;
    });
  };

  init();
};

try {
  scAccordionFilter();
} catch (e) {
  console.error("Accordion Filter Error: ", e);
}